function getDefaultApiBaseUrl(): string {
  if (typeof window !== 'undefined') {
    const { hostname, origin } = window.location;
    // Local dev: Vite serves the UI while the Go API runs on :8000 (`make run`).
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'http://localhost:8000/api';
    }
    // Production: the single binary serves the UI and API on the same origin.
    return `${origin}/api`;
  }
  return 'http://localhost:8000/api';
}

export const API_BASE_URL: string =
  (import.meta.env.VITE_API_BASE_URL as string | undefined) || getDefaultApiBaseUrl();
